/**
 * GoDatePipe created by karora on 14/03/17.
 */
import { Pipe, PipeTransform } from '@angular/core';
import {AppComponent} from "../app.component";
/*
 * Format a stringified ISO8601 date more prettily
 */
@Pipe({
    name: 'smalltime',
    standalone: false
})
export class SmallTimePipe implements PipeTransform {
  private static months: string[] = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  transform(value: string): string {
    try {
      let d = new Date(value);
      let s: string = AppComponent.zpad(d.getHours(), 2) + ':' + AppComponent.zpad(d.getMinutes(), 2) + ', ' + SmallTimePipe.months[d.getMonth()] + ' ' + d.getDate();
      return s;
    } catch(err) {
      console.debug(err);
      return value;
    }
  }
}
